import { Component, Inject, ElementRef, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppWorkCenters } from '../../../core/models/appWorkCenters.model';
import { AppWorkCentersService } from '../../../core/services/appWorkCentersService.service';
import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { HttpClient } from '@angular/common/http';
import { LicenseCheckerService } from '../../../core/helper/licenseChecker';

@Component({
  selector: 'app-edit-centros-dialog',
  templateUrl: './edit-centros-dialog.component.html',
  styleUrls: ['./edit-centros-dialog.component.scss'],
  providers: [AppWorkCentersService, LicenseCheckerService]
})
export class EditCentrosDialog {

  panelIcon = 'vector-square'; // font awesome icon
  panelTitle = 'Crear centro';
  panelDescription = '';
  appAppWorkCentersModel: AppWorkCenters;
  @ViewChild('scrollableSection', { static: false }) scrollableSection: ElementRef;
  isNew: boolean = false;
  markers: any[] = [];
  center: any;
  markerUrl = 'https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/images/maps/map-marker.png';
  conectiaLicence: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<EditCentrosDialog>,
    @Inject(MAT_DIALOG_DATA) public inputData: any,
    public appWorkCentersService: AppWorkCentersService,
    public _licenceCheckerService: LicenseCheckerService,
    protected _messageDialog: MessageDialog,
    private cdr: ChangeDetectorRef,
    private http: HttpClient


  ) {

    this.conectiaLicence = this._licenceCheckerService.checkLicense("conectia");
    if (inputData.data) {
      this.panelTitle = `Editar (${this.inputData.data.name})`;
      this.appAppWorkCentersModel = inputData.data
      this.appAppWorkCentersModel.company = this.inputData.companyName
    } else {
      this.appAppWorkCentersModel = new AppWorkCenters({ name: '', enabled: true, geolocation: false, company: inputData.companyName });
      this.isNew = true;

    }

  }


  ngOnInit() {
    const defaultCenter = { lat: 40.416775, lng: -3.703790 };
    const coordinates = this.appAppWorkCentersModel?.coordinates;


    if (coordinates) {
      const [lat, lng] = coordinates.split(',').map(coord => parseFloat(coord.trim()));
      this.center = { lat, lng };

    } else {
      this.center = defaultCenter;
    }
    this.cdr.detectChanges();

  }

  onMapReady(e: any) {
    setTimeout(() => {
      this.setMarker(this.center);
    }, 100);
  }

  private setMarker(location: { lat: number, lng: number }) {
    this.markers = [
      {
        location,
        iconSrc: this.markerUrl,
        width: 30,
        height: 30,
        onClick: () => this.reverseGeocode(location.lat, location.lng) // Obtiene dirección al hacer clic
      }
    ];
  }


  closePopUp() {
    this.dialogRef.close();
  }

  onEditorPreparing(e): void {
    if (e.parentType === 'searchPanel') {
      e.editorOptions.stylingMode = 'underlined';
    }
  }

  onCoordinatesChange(newCoordinates: string): void {
    const [lat, lng] = newCoordinates.split(',').map(coord => parseFloat(coord.trim()));
    if (!isNaN(lat) && !isNaN(lng)) {
      this.center = { lat, lng };
      this.setMarker(this.center);
      this.reverseGeocode(lat, lng)
    }
    this.cdr.detectChanges();
  }


  onAddressChange(address: string): void {

    this.geocodeAddressNominatim(address).then((coordinates) => {
      if (coordinates) {
        this.center = coordinates;
        this.setMarker(this.center);;
        this.appAppWorkCentersModel.coordinates = `${coordinates.lat}, ${coordinates.lng}`;
        this.cdr.detectChanges();
      }
    });
  }

  private geocodeAddressNominatim(address: string): Promise<{ lat: number; lng: number } | null> {
    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`;

    return this.http.get(url).toPromise().then((response: any) => {
      if (response && response.length > 0) {
        const location = response[0];
        return { lat: parseFloat(location.lat), lng: parseFloat(location.lon) };
      }
      return null;
    }).catch(() => null);
  }

  private reverseGeocode(lat: number, lng: number): void {
    const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`;
    this.http.get(url).subscribe((response: any) => {
      if (response && response.address) {
        this.appAppWorkCentersModel.address = response.display_name; // Actualiza la dirección en el modelo
      }
    });
  }




  workCenterSelectedChange(value: { value: string, name: string }) {
    this.appAppWorkCentersModel.name = value.name;
    this.appAppWorkCentersModel.workplaceCode = Number(value.value);
  }

  enabledSelectedChange(value: string) {
    if ((value === 'true') !== this.appAppWorkCentersModel.enabled) {
      this.appAppWorkCentersModel.enabled = (value === 'true');
    }
  }

  enabledGeolocationChange(value: string) {
    if ((value === 'true') !== this.appAppWorkCentersModel.geolocation) {
      this.appAppWorkCentersModel.geolocation = (value === 'true');
    }
  }

  addMarker(event: any): void {
    const { location } = event;
    this.markers = [{ location }];
    this.center = location;
    this.appAppWorkCentersModel.coordinates = `${location.lat}, ${location.lng}`;
    this.reverseGeocode(location.lat, location.lng)
    this.cdr.detectChanges();
  }

  onSubmit(): void {
    this.appAppWorkCentersModel.companyId = this.inputData.companyData.company1;

    if (this.inputData.data) {
      this.appWorkCentersService.updateModel(this.appAppWorkCentersModel.workCenter1, this.appAppWorkCentersModel).subscribe(
        (response) => {
          this.closePopUp();
        },
        (error) => {
          console.error('Error al editar:', error);
        }
      );
    } else {

      this.appWorkCentersService.createModel(this.appAppWorkCentersModel).subscribe(
        (response) => {
          this.closePopUp();
        },
        (error) => {
          console.error('Error al crear el registro:', error);
        }
      );
    }
  }




}